import React, { Suspense ,useEffect} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import 'animate.css'; 
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Home = React.lazy(() => import("./pages/Home"));
function App() {

  useEffect(() => {
    const scripts = [
      "https://code.jquery.com/jquery-3.4.1.min.js", // Load jQuery first
      "https://cdn.jsdelivr.net/npm/bootstrap@5.0.0/dist/js/bootstrap.bundle.min.js", // Bootstrap JS
      "lib/wow/wow.min.js", // Local file paths after jQuery
      "lib/easing/easing.min.js",
      "lib/waypoints/waypoints.min.js",
      "lib/counterup/counterup.min.js",
      "lib/owlcarousel/owl.carousel.min.js",
      "lib/tempusdominus/js/moment.min.js",
      "lib/tempusdominus/js/moment-timezone.min.js",
      "lib/tempusdominus/js/tempusdominus-bootstrap-4.min.js",
      "js/main.js" ,
    ];
  
    const addedScripts = [];
  
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src; // Directly use the full URL here
        script.async = true;
        script.onload = () => resolve(script);
        script.onerror = () => reject(new Error(`Script load error for ${src}`));
        document.body.appendChild(script);
        addedScripts.push(script);
      });
    };
  
    const loadScripts = async () => {
      for (const src of scripts) {
        try {
          await loadScript(src);
        } catch (error) {
          console.error(error);
        }
      }
    };
  
    loadScripts();
  
    return () => {
      addedScripts.forEach((script) => {
        if (script && script.parentNode === document.body) {
          document.body.removeChild(script);
        }
      });
    };
  }, []);
  
  

  return (
    <Router>
  
        <Suspense>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </Suspense>
    </Router>
  );
}

export default App;
